import { Component, Inject, OnInit } from '@angular/core'
import { MatDialogRef, MAT_DIALOG_DATA, MatSnackBar } from '@angular/material'
import { FormGroup } from '@angular/forms'
interface DialogData {
  text: string
  buttonConfirmText: string
  buttonNot: string
}

@Component({
  selector: 'app-modal',
  templateUrl: './modal-confirm.component.html',
  styleUrls: ['./modal-confirm.component.scss'],
})
export class ModalConfirmComponent implements OnInit {
  public formGroup: FormGroup

  constructor (
    public dialogRef: MatDialogRef<ModalConfirmComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    public snackBar: MatSnackBar,
  ) {
    console.log('data', data)
  }

  cancel (): void {
    this.dialogRef.close('cancel')
  }

  confirm () {
    this.dialogRef.close(1)
  }

  not () {
    this.dialogRef.close('not')
  }

  ngOnInit () {
    // empty
  }
}
